import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderMobile from './SiteHeaderMobile';
const SiteHeader = (props)=>{
    const isMobile = useContext(MobileContext);
    return isMobile ? /*#__PURE__*/ React.createElement(SiteHeaderMobile, props) : /*#__PURE__*/ React.createElement(SiteHeaderDesktop, props);
};
SiteHeader.displayName = 'SiteHeader';
export default SiteHeader;

//# sourceMappingURL=SiteHeader.js.map